function ErrorPage() {
  return (
    <img style={{display:"block",marginRight:"auto",marginLeft:"auto"}}
      src="https://miro.medium.com/max/1400/0*h-HdveuCxbTYOHzV.gif"
      alt="404 Error" />
  )
}

export default ErrorPage